import React from 'react';
import { Button } from 'antd';

const CsvDownloadButton = ({ title, onClick, disabled, closeMenu }) => {
  return (
    <Button
      style={{ backgroundColor: '#1890ff', color: '#ffffff', width: '100%' }}
      onClick={() => {
        onClick();
        closeMenu();
      }}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

export default CsvDownloadButton;
